'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

var icon = require('../setting/icon.base64.js');
exports.default = {
  props: {
    title: '',
    isFolded: {
      type: Boolean,
      default: true
    }
  },
  // watch: {
  //   isFolded(value) {
  //     this.isFoldedStatus = value;
  //   }
  // },
  data: function data() {
    return {
      unfoldIcon: icon['service_ic_show@3x'],
      foldIcon: icon['service_ic_hide@3x']
      // isFoldedStatus: true
    };
  },

  methods: {
    makeSwitch: function makeSwitch() {
      this.isFolded = !this.isFolded;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-accordion/index.vue
// module id = 300
// module chunks = 0 1